<template>
  <router-link
    to="/pos/subscription"
    data-test="subscription-callout"
    class="flex items-center justify-between gap-3 rounded-xl bg-gray-900 p-5 text-white shadow-xs hover:bg-gray-800 transition-colors"
  >
    <span class="text-lg font-bold">{{ t("new_subscription") }}</span>
    <ArrowRightIcon class="h-5 w-5" />
  </router-link>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ArrowRightIcon } from "@heroicons/vue/solid";

// Main action of the POS home: the whole block is the button that starts a subscription.
export default {
  components: {
    ArrowRightIcon,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./ActionCallout.i18n.json"></i18n>
